import styled from 'styled-components';
import { Colors, Media, TextStylesDesktop, TextStylesMobile } from 'enums';
import { IErrorProps } from './ErrorText';

export const ErrorText = styled.div<IErrorProps>`
  ${TextStylesMobile.small1}
  color: ${() => Colors.red1};

  @media ${Media.notebook} {
    ${TextStylesDesktop.small1};
  }
`;
